import MockAuthAdapter from "./MockAuthAdapter";
import JwtAuthAdapter from "./JwtAuthAdapter";

/**
 * Aktif auth adapter — env değişkenine göre seçilir.
 * REACT_APP_AUTH_MODE=mock (default) | jwt
 */
const mode = import.meta.env.VITE_AUTH_MODE || "mock";

const auth = mode === "jwt" ? JwtAuthAdapter : MockAuthAdapter;

export default auth;
export { MockAuthAdapter, JwtAuthAdapter };
export { AUTH_TOKEN_KEY, AUTH_USER_KEY } from "./AuthAdapter";
